export default __webpack_public_path__ + "static/media/bet.647125f7.mp3";